
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://wajmeqsfcgruhuxasuux.supabase.co';
const SUPABASE_KEY = 'sb_publishable_CvIBWIOhrKX3kGNKNwzlFg_7fUZzOUk';

// Instância única exportada para todo o app
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
